import { ActionTypes } from '../constants/index';

export const fetchReportedUserList = (payload: any) => ({
  type: ActionTypes.REPORTED_USER_MGMT_REQUEST,
  payload: {
    page: payload.page,
    rowsPerPage: payload.rowsPerPage,
    startDate: payload.startDate,
    endDate: payload.endDate,
    userType: payload.userType,
    search: payload.search,
    isSortByUsername: payload.isSortByUsername,
    isSortByCreated: payload.isSortByCreated,
  },
});
